<template>
  <div>
    <h5 class="card-title">发件人白名单</h5>
    <h6 class="card-subtitle text-muted">只接收发件人地址中包含以下关键字的邮件</h6><hr>
    <form>

      <div class="form-group">
        <label for="exampleFormControlTextarea1">如有多个条件以逗号（小写）分隔,例如：@haier.com, 126.com</label>
        <textarea class="form-control" id="exampleFormControlTextarea1" rows="10" placeholder="例如：@haier.com; 126.com" 
          :autofocus="true"
          v-model="whitelistDto.keywords"></textarea>
      </div>
      <button type="submit" class="btn btn-primary" @click="save">保存</button>

    </form>

  </div>
</template>

<script>
import * as mailboxFacade from "../../../api/mailbox-facade.js";

export default {
  // validations:
  props:{
    orgId: String,
  },
  data() {
    return {
      whitelistDto: {}
    };
  },

  created() {
  },
  mounted() {
    this.getWhitelistInfo(this.orgId)
  },
  methods: {
    getWhitelistInfo(orgId){
      this.pageLoading = true;
      mailboxFacade
        .obtainWhitelist(orgId)
        .then(res => {
          this.pageLoading = false;
          this.whitelistDto = res;
        })
        .catch(err => {
          console.log("err", err);
          this.pageLoading = false;
        });
    },

    save(){
      mailboxFacade
        .saveWhitelist(this.whitelistDto)
        .then(()=>{
          this.$message({
            message: "白名单设置成功",
            type: "success"
          });
        })
        .catch(err => {
          console.log("err", err);
          this.pageLoading = false;
        });
    },

  }
};
</script>

<style >
</style>
